import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Navbar from "./components/Navbar"
import Footer from "./components/Footer"
import HomePage from "./pages/HomePage"
import ProductsPage from "./pages/ProductsPage"
import BlogPage from "./pages/BlogPage"
import QuoteRequest from "./pages/QuoteRequest"
import BuyingGuide from "./pages/BuyingGuide"
import SafetyGuidelines from "./pages/SafetyGuidelines"
import MaintenancePage from "./pages/MaintenancePage"
import FAQPage from "./pages/FAQPage"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import ContactInfo from "./pages/ContactInfo"
import ComparisonTool from "./pages/ComparisonTool"

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-zinc-900 flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/buying-guide" element={<BuyingGuide />} />
            <Route path="/safety" element={<SafetyGuidelines />} />
            <Route path="/maintenance" element={<MaintenancePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<ContactInfo />} />
            <Route path="/comparison" element={<ComparisonTool />} />
            <Route path="/quote" element={<QuoteRequest />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
